export default "__VITE_ASSET__HNsFmyG___"